import { Box, Text } from "@chakra-ui/layout";
import { Modal } from "antd";
import { useCriarEditarAnimal } from "core/features/animal/hooks/useCriarEditarAnimal";
import { useDetalhesAnimal } from "core/features/animal/hooks/useDetalhesAnimal";
import { useListarTiposAnimal } from "core/features/animal/hooks/useListarTiposAnimal";
import { AnimalForm } from "core/features/animal/typings";
import { showErrorAxios, useLoading } from "infra/helpers/alerta";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FooterModal from "ui/components/Button/FooterModal";
import FormPet from "./FormPet";

interface ModalCadastroPetProps {
  isOpen: boolean;
  unidadeId: string;
  onClose: () => any;
  onSaved: any;
  id?: string;
}

function ModalCadastroPet({
  isOpen,
  unidadeId,
  id,
  onClose,
  onSaved,
}: ModalCadastroPetProps) {
  const [registerAnother, setRegisterAnother] = useState(false);

  const { data: pet, isLoading: isLoadingDetalhesAnimal } =
    useDetalhesAnimal(id);

  const { data: tiposAnimal, isLoading: isLoadingTiposAnimal } =
    useListarTiposAnimal();

  const { mutate: handleSave, isLoading } = useCriarEditarAnimal();

  const handleModalSubmit = async (data: AnimalForm) => {
    handleSave(
      { ...data, unidadeId },
      {
        onSuccess: () => {
          setTimeout(() => {
            onSaved();

            if (!registerAnother) {
              onClose();
            } else {
              reset({});
            }
          }, 200);
        },
        onError: (err) => {
          showErrorAxios(err);
        },
      }
    );
  };

  const { control, handleSubmit, watch, formState, reset } =
    useForm<AnimalForm>({
      reValidateMode: "onChange",
      mode: "all",
    });

  useLoading(isLoading || isLoadingDetalhesAnimal || isLoadingTiposAnimal);

  useEffect(() => {
    if (isOpen) {
      reset({});
    }
  }, [isOpen, reset]);

  useEffect(() => {
    if (pet) {
      reset({ ...pet, docio: pet.docio ? 1 : 0 });
    }
  }, [pet, reset]);

  return (
    <Modal
      destroyOnClose
      width="800px"
      footer={
        <FooterModal
          registerAnother={registerAnother}
          setRegisterAnother={setRegisterAnother}
          showRegisterAnother={!unidadeId}
          onSubmit={handleSubmit(handleModalSubmit)}
          onClose={onClose}
          isLoadingSave={isLoading}
          isDisabled={!formState.isValid}
        />
      }
      centered
      bodyStyle={{
        height: "max(80vh, 400px)",
        overflow: "auto",
        paddingBottom: 16,
      }}
      visible={isOpen}
      onCancel={onClose}
    >
      <Box pt={4} pb={6}>
        <form onSubmit={(ev) => handleSubmit(handleModalSubmit)(ev)}>
          <>
            <Text as="h3" fontSize={20}>
              {pet?.id ? "Editar" : "Cadastrar"} pet
            </Text>

            <Box pt="16px">
              <FormPet
                control={control}
                watch={watch}
                tiposAnimal={tiposAnimal}
              />
            </Box>
          </>
        </form>
      </Box>
    </Modal>
  );
}

export default ModalCadastroPet;
